import React, { createContext, useState, useContext, useEffect } from 'react';
import { login as authLogin, logout as authLogout, isAuthenticated, getUsername } from '../utils/auth';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAuth, setIsAuth] = useState(false);

  useEffect(() => {
    if (isAuthenticated()) {
      setUser({ username: getUsername() });
      setIsAuth(true);
    }
  }, []);

  const login = (username, password) => {
    const result = authLogin(username, password);
    if (result.success) {
      setUser({ username });
      setIsAuth(true);
    }
    return result;
  };

  const logout = () => {
    authLogout();
    setUser(null);
    setIsAuth(false);
  };

  return (
    <AuthContext.Provider value={{ user, isAuth, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
